import React from 'react';
export function SectionImage3() {
  return <section className="w-full" data-id="element-118">
      <img src="https://cdn.shopify.com/s/files/1/1019/9361/1596/files/hf_20260302_180501_44e1e842-f55e-4426-990d-0249a7ee5ba3.jpg?v=1772970715" alt="Sección promocional 3" className="w-full block" style={{
      display: 'block'
    }} data-id="element-119" />
    </section>;
}